import { StepBasicInfo } from "./StepBasicInfo";
import { StepSchedule } from "./StepSchedule";
import { StepAudience } from "./StepAudience";
import { StepSendRules } from "./StepSendRules/StepSendRules";
import { StepChannelsTemplates } from "./StepChannelsTemplates/StepChannelsTemplates";

export const CAMPAIGN_WIZARD_STEPS = [
  { id: "basic", label: "Informações básicas", component: StepBasicInfo },
  { id: "schedule", label: "Período e Agendamento", component: StepSchedule },
  { id: "audience", label: "Público Alvo (Listagem)", component: StepAudience },
  { id: "sendRules", label: "Regras de envio", component: StepSendRules },
  { id: "channels", label: "Canais e Modelos", component: StepChannelsTemplates },
];